export const homeObjOne = {
  id: "business",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Community First",
  headLine: "Small Business loans for Daily Expenses",
  description:
    "We enjoy Working together. Our low interest rate can save you hundreds of dollars over the life of your loan.",
  buttonLabel: "Apply Now",
  imgStart: false,
  img: require("../../images/main1.svg"),
  alt: "Wallet",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjTwo = {
  id: "join",
  lightBg: true,
  lightText: false,
  lightTextDesc: true,
  topLine: "Better and Secure Life",
  headLine: "Get your Free Account Today ",
  description:
    "Whether you live on the coast or in the mountains,Apply for our high yields credit to boost your savings.",
  buttonLabel: "Learn More",
  imgStart: true,
  img: require("../../images/main2.svg"),
  alt: "Credit",
  dark: false,
  primary: false,
  darkText: true,
};

export const homeObjThree = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Smart Banking",
  headLine: "Find out which saving account is right for you.",
  description:
    "Credit Union is commited to offering the most efficient,effective and secure way of delivering your financial information.",
  buttonLabel: "Get Started",
  imgStart: false,
  img: require("../../images/main3.svg"),
  alt: "card",
  dark: true,
  primary: true,
  darkText: false,
};
